import React, { Fragment } from "react";

// Runtime white-label config — set by nginx-mounted /app-config.js
const cfg = window.APP_CONFIG || {};
const appName = cfg.appName || "Fincrest Systems";

class AppFooter extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="app-footer">
          <div className="app-footer__inner" style={{ justifyContent: 'center', textAlign: 'center', width: '100%' }}>
            <span>© Copyright {appName}</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AppFooter;
